<template>
  <div>
    <Dialog
      v-model="dialogStore.passwordChange.isOpen"
      size="small-hug"
    >
      <template #header="{ close }">
        <DialogHeader
          :title="useT('bcd19')"
          :show-close="true"
          @close="close"
        />
      </template>

      <Form
        ref="formRef"
        :model="form"
        :rules="rules"
        @submit="onSubmit"
      >
        <InputBlock
          :label="useT('bcd20')"
          prop="oldPassword"
        >
          <TextInput
            v-model="form.oldPassword"
            type="password"
            name="oldPassword"
            :placeholder="useT('bcd21')"
            autocomplete="current-password"
            data-private
          />
        </InputBlock>

        <InputBlock
          :label="useT('bcd22')"
          prop="password"
        >
          <TextInput
            v-model="form.password"
            type="password"
            name="password"
            :placeholder="useT('bcd21')"
            autocomplete="new-password"
            data-private
            @focus="isPasswordFocus = true"
            @blur="isPasswordFocus = false"
          />

          <client-only>
            <el-collapse-transition>
              <UserPasswordStrength
                v-show="isPasswordFocus"
                :password="form.password"
                :rules="rules.password"
              />
            </el-collapse-transition>
          </client-only>
        </InputBlock>

        <InputBlock
          :label="useT('bcd23')"
          prop="passwordConfirm"
          class="mb-0"
        >
          <TextInput
            v-model="form.passwordConfirm"
            type="password"
            name="passwordConfirm"
            :placeholder="useT('bcd21')"
            autocomplete="new-password"
          />
        </InputBlock>
      </Form>

      <template
        #footer
      >
        <ButtonGroup
          type="primary"
          :text-submit="useT('bcd24')"
          :text-cancel="useT('bcd205')"
          :loading="isLoading"
          @submit="formRef.onSubmit()"
          @cancel="useDialogStore().close('passwordChange')"
        />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
// Refs
const dialogStore = useDialogStore();

const form = ref({
  oldPassword: '',
  password: '',
  passwordConfirm: '',
});

const rules = {
  oldPassword: [useFormRules().required],
  password: useFormRules().password,
  passwordConfirm: useFormRules().passwordConfirm(computed(() => form.value.password)),
};

const isLoading = ref(false);
const formRef = ref(null);
const isPasswordFocus = ref(false);

// Methods
const onSubmit = async() => {
  isLoading.value = true;

  const response = await useUsersStore().updateUserMePassword({
    oldPassword: form.value.oldPassword,
    newPassword: form.value.password,
  });

  isLoading.value = false;

  if (response) {
    useToast(useT('bcd46'));
    dialogStore.close('passwordChange');

    form.value = {
      oldPassword: '',
      password: '',
      passwordConfirm: '',
    };
  }
};
</script>
